import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

import PaperFragment from "../../../../helper-components/misc/PaperFragment";
import StackedHeader from "../../../../helper-components/misc/StackedHeader";
import DataGridTable from "../../../../helper-components/table/DataGridTable";

import { columns, defaultTableOptions } from "../../../../helper-functions/table/quotes";
import { deleteQuotes, queryQuotes } from "../../../../helper-functions/api/transcriptQueries";

import { getLanguage } from "../../../../config/language/language";

/**
 * Table showing quotes.
 * If no data found, show error message instead.
 */
export default function QuotesTable(props) {
    const quotes = props.backend.quotes;

    const showDeleteDialog = () => {
        props.showDialog({
            title: "Delete quote(s)",
            message: `Are you sure you want to delete the ${quotes.selected.length} selected quote(s)?

            This action cannot be undone.`,
            actionTitle: "Delete",
            actionColor: "error",
            callback: (confirm) => handleDelete(confirm)
        });
    };

    const handleDelete = (confirm) => {
        if (!confirm) return;

        const ids = quotes.selected.map((q) => q.id);
        deleteQuotes(props, { body: { ids }, ids });
    };

    return (
        <PaperFragment
            className="tour-quotes-3 tour-quotes-4"
            title={
                <StackedHeader
                    {...props}
                    title="Quotes"
                    subtitle="View and manage quotes."
                    icons={[
                        {
                            icon: <DeleteIcon />,
                            tooltip: "Delete selected quotes",
                            disabled: quotes.selected.length < 1,
                            onClick: showDeleteDialog
                        }
                    ]}
                />
            }
            value={
                <DataGridTable
                    {...props}
                    {...defaultTableOptions}
                    rowHeight={60}
                    states={quotes}
                    columns={columns(props)}
                    query={(options) => queryQuotes(props, options)}
                    empty={getLanguage().NO_QUOTES_FOUND}
                    refresh={10}
                />
            }
        />
    );
}
